import API from './api';

export default class ProductApi {
  static getList(params) {
    return API.get('/advertisers/products', params);
  }
}
